import React, { useEffect, useState } from "react";
import { ChevronDown, Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CinematicFeature() {
  const [scrollY, setScrollY] = useState(0);
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="47699" id="pulse-of-the-sacred" className="relative h-screen w-full overflow-hidden bg-black text-foreground dark">
      {}
      <div className="absolute inset-0 z-0 md:h-[120%] h-full w-full" style={{
      transform: `translateY(${scrollY * 0.5}px)`
    }}>
        <video autoPlay muted loop playsInline className="h-full w-full object-cover object-[40%_50%] md:object-center">
          <source src="https://videos.pexels.com/video-files/5377684/5377684-uhd_2560_1440_25fps.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-black/50 backdrop-contrast-125" />
      </div>

      {}
      <div className="relative z-10 flex h-full flex-col items-end justify-end pb-24 px-4 text-right">
        <div ref={textRef} className={`flex flex-col items-end transition-all duration-1000 ease-out ${textVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <h1 className="font-default text-6xl font-bold tracking-tighter text-white sm:text-8xl md:text-9xl lg:text-[10vw] drop-shadow-[0_0_30px_rgba(255,255,255,0.2)] uppercase">DANCE.</h1>
          
          <p className="mt-6 max-w-2xl text-lg text-foreground/80 md:text-xl font-sans tracking-widest uppercase">&nbsp;immerse YOURSELF IN THE rhythm of collective connection.</p>

          <div className="mt-10">
            <Button asChild size="lg" className="group relative h-14 overflow-hidden bg-[linear-gradient(135deg,#2e1065_0%,#7c3aed_50%,#a855f7_100%)] px-10 text-lg font-default font-semibold text-white transition-all duration-300 hover:scale-105 hover:shadow-[0_0_40px_rgba(168,85,247,0.4)]">
              
            </Button>
          </div>
        </div>
      </div>

      </section>;
}